import { gql } from '@grandvisionhq/graphql';
import { productFragment } from './fragments/product.js';
import { commercialCategoryFragment } from './fragments/small-fragments.js';
import { variantFragment } from './fragments/variant.js';

const GET_ACCESSORIES_BY_SLUG = gql`
  query GetAccessoriesBySlug($slug: String!, $facets: [SearchFacetInput!]!) {
    getProductBySlug(slug: $slug, facets: $facets) {
      product {
        __typename
        ... on AccessoriesProduct {
          id
          ...productFragment
          commercialCategories {
            ...CommercialCategoryFragment
          }
          variants {
            ...variantFragment
            variantTypeDetails {
              channelAvailability
              recommendedCategoryKey
              brandModelCode
              brandModelColorCode
              targetGender
              targetGenderAllLocales {
                value
                locale
              }
              color
              colorAllLocales {
                locale
                value
              }
              material
              materialAllLocales {
                locale
                value
              }
              accessoryType {
                displayName
                displayNameAllLocales {
                  locale
                  value
                }
              }
              tags {
                key
                value
              }
            }
          }
        }
      }
    }
  }
  ${productFragment}
  ${commercialCategoryFragment}
  ${variantFragment}
`;

export { GET_ACCESSORIES_BY_SLUG };
//# sourceMappingURL=get-accessories-by-slug.js.map
